var _rect, _rect2, _text, _text2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 340,
    viewBox: "0 0 600 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 340,
    fill: "#0d1b2a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 560,
    height: 300,
    rx: 8,
    fill: "#112240",
    stroke: "#64ffda",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 90,
    fontFamily: "monospace",
    fontSize: 20,
    fill: "#64ffda",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "World Bank API Data Pipeline")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 125,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#8892b0",
    textAnchor: "middle"
  }, "84 Indicators \xB7 184 Countries \xB7 ML Deployment")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 145,
    width: 440,
    height: 2,
    fill: "#64ffda",
    opacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 230,
    width: 30,
    height: 60,
    fill: "#64ffda",
    opacity: 0.4,
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 205,
    width: 30,
    height: 85,
    fill: "#64ffda",
    opacity: 0.5,
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 185,
    width: 30,
    height: 105,
    fill: "#64ffda",
    opacity: 0.6,
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 215,
    width: 30,
    height: 75,
    fill: "#64ffda",
    opacity: 0.5,
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 175,
    width: 30,
    height: 115,
    fill: "#64ffda",
    opacity: 0.7,
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 195,
    width: 30,
    height: 95,
    fill: "#64ffda",
    opacity: 0.6,
    rx: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 210,
    width: 30,
    height: 80,
    fill: "#64ffda",
    opacity: 0.5,
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 220,
    width: 30,
    height: 70,
    fill: "#64ffda",
    opacity: 0.4,
    rx: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 200,
    width: 30,
    height: 90,
    fill: "#64ffda",
    opacity: 0.55,
    rx: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 315,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#a8b2d8",
    textAnchor: "middle"
  }, "Python \xB7 NumPy \xB7 Gemini API \xB7 Streamlit")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP15);
export default __webpack_public_path__ + "static/media/p15.85922ebbfa1f06c022d3f251874a2db6.svg";
export { ForwardRef as ReactComponent };